var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"0 15px"},on:{"click":_vm.toggleClick}},[(!_vm.isActive)?_c('i',{staticClass:"hamburger el-icon-s-unfold"}):_vm._e(),(_vm.isActive)?_c('i',{staticClass:"hamburger el-icon-s-fold"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }